/** Author listing is course scoped by the API; fetch every cursor, not just its first page. */
export async function loadLearningAssessmentOptions(request, kind, courseId) {
  if (!['quiz', 'assignment'].includes(kind) || !Number.isSafeInteger(Number(courseId)) || Number(courseId) < 1) throw new Error('invalid_reference_context');
  const path = kind === 'quiz' ? '/quizzes' : '/assignments';
  const items = new Map();
  let cursor = 0;
  do {
    const page = await request(path + '?' + new URLSearchParams({ course_id: String(courseId), limit: '100', cursor: String(cursor) }));
    for (const row of page.items || []) {
      if (Number(row.course_id) !== Number(courseId)) throw new Error('invalid_reference_context');
      if (Number(row.id) > 0 && row.status !== 'archived') items.set(Number(row.id), { id: Number(row.id), title: String(row.title), status: row.status });
    }
    if (!page.next_cursor) break;
    const next = Number(page.next_cursor);
    if (!Number.isSafeInteger(next) || next <= cursor) throw new Error('invalid_reference_cursor');
    cursor = next;
  } while (true);
  return [...items.values()];
}

/** Reuse the existing tenant/owner-scoped auto-webinar API and its page-size contract. */
export async function loadLearningAutoWebinarOptions(fetchImpl = window.fetch.bind(window)) {
  const items = []; const seen = new Set(); let page = 1;
  do {
    const response = await fetchImpl(`/api/auto-webinars/v1/webinars?page=${page}`, { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok || result.error) { const error = new Error(result.error?.message || 'reference_access_required'); error.status = response.status; throw error; }
    if (!Array.isArray(result.data?.items) || Number(result.data.page) !== page) throw new Error('invalid_reference_cursor');
    for (const row of result.data.items) {
      const id = Number(row.id);
      if (!Number.isSafeInteger(id) || id < 1 || seen.has(id)) throw new Error('invalid_reference_cursor');
      seen.add(id);
      if (row.status !== 'archived') items.push({ id, title: String(row.title), status: row.status });
    }
    if (result.data.items.length < 25) return items;
    page++;
  } while (page <= 100000);
  throw new Error('invalid_reference_cursor');
}
